import {Button, Stack, styled} from '@mui/material';
import {HeaderContainerProps} from './types';

const HeaderAppointmentsContainer = styled(Stack)<HeaderContainerProps>`
	flex-direction: row;
	align-items: ${({$showActionButton}) => ($showActionButton ? 'flex-start' : 'center')};
	justify-content: space-between;
`;

const ActionButton = styled(Button)`
	padding: 0px;
`;

export {ActionButton, HeaderAppointmentsContainer};
